import { Injectable, createInterfaceId } from "@gitlab/needle";
import { posix, relative } from "path";
import { URI, Utils } from "vscode-uri";
//#region src/virtual_file_system_service.ts
/**
* Events emitted by the `VirtualFileSystemService`.
* TODO: potentially make these separate event emitters to subscribe to individually
*/
let VirtualFileSystemEvents = /* @__PURE__ */ function(VirtualFileSystemEvents) {
	/**
	* Emitted when a single file is added, changed, or deleted in a workspace folder.
	*/
	VirtualFileSystemEvents["WorkspaceFileEvent"] = "workspaceFileEvent";
	/**
	* Emitted when multiple files are added, changed, or deleted in a workspace folder.
	* This will happen when a workspace folder is initialized via a config change.
	* Under the hood, this uses the `DirectoryWalker` to find all files in the workspace folder.
	*/
	VirtualFileSystemEvents["WorkspaceFilesEvent"] = "workspaceFilesEvent";
	return VirtualFileSystemEvents;
}({});
const FILE_SYSTEM_EVENT_NAME = "fileSystemEvent";
const VirtualFileSystemService = createInterfaceId("VirtualFileSystemService");
//#endregion
//#region src/file_access_service.ts
const LSP_PRIORITY = 2;
const FS_PRIORITY = 1;
var FileNotFoundError = class extends Error {
	name = "FileNotFoundError";
	constructor(path, cause) {
		super(`File not found: ${path}`);
		this.cause = cause;
	}
};
var ConcurrentFileModificationError = class extends Error {
	name = "ConcurrentFileModificationError";
	constructor(path) {
		super(`File "${path}" was modified concurrently while this edit was being applied. Read the file again before retrying.`);
	}
};
const FileAccessService = createInterfaceId("FileAccessService");
//#endregion
//#region src/fs_client.ts
const FsClient = createInterfaceId("FsClient");
//#endregion
//#region src/empty_fs_client.ts
let _initClass;
function _applyDecs(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey(t) {
	var i = _toPrimitive(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const notImplemented = async () => {
	throw new Error("Not implemented");
};
let _EmptyFsClient;
(class {
	static {
		[_EmptyFsClient, _initClass] = _applyDecs(this, [Injectable(FsClient, [])], []).c;
	}
	promises = {
		readFile: notImplemented,
		writeFile: notImplemented,
		unlink: notImplemented,
		readdir: notImplemented,
		mkdir: notImplemented,
		rmdir: notImplemented,
		stat: notImplemented,
		lstat: notImplemented,
		readFileFirstBytes: notImplemented
	};
	static {
		_initClass();
	}
});
//#endregion
//#region src/utils/binary_content.ts
const BINARY_CHECK_BYTES = 8192;
/**
* Checks if a file contains binary content by examining its first bytes.
* @throws {NodeJS.ErrnoException} If the file does not exist or cannot be accessed (ENOENT, EPERM, EACCES, etc.)
*/
async function isBinaryFile(uri, fsClient) {
	const { stat, readFileFirstBytes } = fsClient.promises;
	await stat(uri.fsPath);
	try {
		return isBinaryContent(await readFileFirstBytes(uri.fsPath, BINARY_CHECK_BYTES));
	} catch {
		return true;
	}
}
function isBinaryContent(content) {
	if (content.startsWith("﻿") || content.startsWith("￾")) return false;
	if (content.startsWith("%PDF-")) return true;
	const NULL_BYTE_REGEX = /\x00/;
	const CONTROL_CHARS_REGEX = /[\x00-\x08\x0B\x0C\x0E-\x1F]/;
	const contentToCheck = content.slice(0, BINARY_CHECK_BYTES);
	return NULL_BYTE_REGEX.test(contentToCheck) || CONTROL_CHARS_REGEX.test(contentToCheck);
}
//#endregion
//#region src/utils/path_utils.ts
const fsPathToUri = (fsPath) => {
	return URI.file(fsPath);
};
const fsPathFromUri = (fsUri) => {
	return fsUri.fsPath;
};
const parseURIString = (uri) => {
	return URI.parse(uri);
};
function isFileSchemeUri(uri) {
	return uri.startsWith("file:");
}
function isVirtualWorkspaceUri(uri) {
	return Boolean(uri) && !isFileSchemeUri(uri);
}
/** For non-file:// URIs returns the path component (avoids fileURLToPath throwing). */
function workspaceFolderPathFromUri(uri) {
	const parsed = URI.parse(uri);
	if (parsed.scheme === "file") return parsed.fsPath;
	return parsed.path || "/";
}
/** For virtual workspaces, joins via vscode-uri so the key matches didOpen URIs. */
function fileLookupKey(workspaceFolderPath, workspaceFolderUri, filePath) {
	if (isVirtualWorkspaceUri(workspaceFolderUri)) return Utils.joinPath(URI.parse(workspaceFolderUri), filePath).toString();
	return posix.join(workspaceFolderPath, filePath);
}
const getPlatform = () => {
	return process?.platform ?? "browser";
};
function splitPath(path) {
	return decodeURIComponent(path).split(/[/\\]+/).filter(Boolean);
}
/**
* Takes a Windows OS path and changes backward slashes to forward slashes.
* This should only be done for OS paths from Windows (or user provided paths potentially from Windows).
* Using it on a Linux or MaxOS path might change it.
*/
function toSlashes(osPath) {
	return osPath.replace(/[\\/]/g, "/");
}
function ignorePathCasing(uri, isLinux) {
	return uri.scheme === "file" ? !isLinux : true;
}
function getRelativePath(from, to) {
	const processPlatform = getPlatform();
	if (from.scheme === "file") {
		const relativePath = relative(from.fsPath, to.fsPath);
		return processPlatform === "win32" ? toSlashes(relativePath) : relativePath;
	}
	let fromPath = from.path || "/";
	const toPath = to.path || "/";
	if (ignorePathCasing(from, processPlatform === "linux")) {
		let i = 0;
		for (const len = Math.min(fromPath.length, toPath.length); i < len; i++) if (fromPath.charCodeAt(i) !== toPath.charCodeAt(i)) {
			if (fromPath.charAt(i).toLowerCase() !== toPath.charAt(i).toLowerCase()) break;
		}
		fromPath = toPath.substr(0, i) + fromPath.substr(i);
	}
	return posix.relative(fromPath, toPath);
}
const getMatchingWorkspaceFolders = (fileUri, workspaceFolders) => workspaceFolders.filter((wf) => fileUri.startsWith(wf.uri));
//#endregion
export { BINARY_CHECK_BYTES, ConcurrentFileModificationError, _EmptyFsClient as EmptyFsClient, FILE_SYSTEM_EVENT_NAME, FS_PRIORITY, FileAccessService, FileNotFoundError, FsClient, LSP_PRIORITY, VirtualFileSystemEvents, VirtualFileSystemService, fileLookupKey, fsPathFromUri, fsPathToUri, getMatchingWorkspaceFolders, getRelativePath, isBinaryContent, isBinaryFile, isFileSchemeUri, isVirtualWorkspaceUri, parseURIString, splitPath, workspaceFolderPathFromUri };

//# sourceMappingURL=index.mjs.map